module.exports = __webpack_public_path__ + "static/media/right_answer.6bd568d7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/right_answer.gif
// module id = 474
// module chunks = 0